/*
 * @file: Layouts.js
 * @description: Defined all Layouts for application
 * @author: navreet
 */

import React from 'react'
import Header from './headers/Header'
import MainHeader from './headers/MainHeader'
import Footer from './footers/Footer'
import MainFooter from './footers/MainFooter'
import SideBar from './SideBar'
import Error from './error'
// import landingPage from '../../src/containers/landingpage';

/*************** Public Layout ***************/
export const publicLayout = (props) => {
    // window.scrollTo(0, 0)
    const path = props.children.props.history.location.pathname
    return (
        <div>
            {props.children}
            <Error></Error>
        </div>
    )
}

export const faqLayout = (props) => {
    // window.scrollTo(0, 0)
    const path = props.children.props.history.location.pathname
    return <div className="main">{props.children}</div>
}

/*************** Private Layout ***************/
export const privateLayout = (props) => {
    // console.log('PRIVATE::::', props.children.props.history.location)

    // window.scrollTo(0, 0)
    return (
        <div className="main">
            <Error></Error>
            <div className="header" style={{ position: 'fixed', background: 'white' }}>
                <Header />
            </div>
            <div style={{ display: 'flex' }}>
                <SideBar />
                <div className="content-wrapper">{props.children}</div>
            </div>
        </div>
    )
}

/*************** Landing Page Layout ***************/
export const landingPageLayout = (props) => {
    // window.scrollTo(0, 0)
    const path = props.children.props.history.location.pathname
    return (
        <div>
            {props.children} <Error></Error>
        </div>
    )
}
/*************** Landing Page Layout ***************/
export const LPMLayout = (props) => {
    // window.scrollTo(0, 0)
    const path = props.children.props.history.location.pathname
    return (
        <div style={{ height: '100%' }}>
            {props.children} <Error></Error>
        </div>
    )
}
